// Copyright (c) 2020, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'
import PropTypes from 'prop-types'

import { SvgIcon } from '../'

import {
  getSldsIconType,
  getFileExtension
} from '../../utils'


export const FileCaption = ({ file, download }) => {
  let fileExtension = getFileExtension(file.asset)
  let fileName = file.asset
    .substr(file.asset.lastIndexOf('/') + 1)  // last part of file asset url (not really necessary if not other '__' in asset name)
    .split('__').pop()  // get part after '__'

  const downloadFile = (file) => {
    if (download) {
      let a = document.createElement('a')
      a.href = file.url
      a.download = true
      a.onclick = (e) => document.body.removeChild(e.target)
      a.style.display = 'none'
      document.body.appendChild(a)
      a.click()
    }
  }

  return (
    <figcaption className='slds-file__title slds-file__title_card' onClick={() => downloadFile(file)}>
      <div className='slds-media slds-media_small slds-media_center slds-align_absolute-center'>
        <div className='slds-media__figure slds-line-height_reset'>
          <span className='slds-icon_container'>
            <SvgIcon
              variant='doctype'
              symbol={getSldsIconType(fileExtension)}
            />
            <span className='slds-assistive-text'>{fileExtension}</span>
          </span>
        </div>
        <div className='slds-media__body'>
          <span title={fileName} className='slds-file__text slds-truncate'>
            {fileName}
          </span>
        </div>
      </div>
    </figcaption>
  )
}

FileCaption.propTypes = {
  file: PropTypes.shape({
    asset: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired
  }).isRequired,
  download: PropTypes.bool
}



// WEBPACK FOOTER //
// ./src/components/file-caption/index.js